import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rounded-xl border border-zinc-700 bg-[#0C0C0C]" }
const _hoisted_2 = { class: "flex items-center gap-2 px-3 py-2 border-b border-zinc-800 bg-[#0C0C0C] sticky top-0 z-10" }
const _hoisted_3 = ["placeholder"]

import {
  onMounted, ref, watch, nextTick,
} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'NoteEditor',
  props: {
    modelValue: {},
    placeholder: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const editorRef = ref<HTMLDivElement | null>(null);
const internalHtml = ref(props.modelValue || '');

watch(() => props.modelValue, (val) => {
  const next = val || '';
  if (next !== internalHtml.value) internalHtml.value = next;
  if (editorRef.value && editorRef.value.innerHTML !== next) {
    editorRef.value.innerHTML = next;
  }
});

function exec(command: 'bold') {
  document.execCommand(command);
}

function formatAs(block: 'p' | 'h1' | 'h2') {
  if (!editorRef.value) return;
  document.execCommand('formatBlock', false, block);
}

function onInput() {
  internalHtml.value = editorRef.value?.innerHTML || '';
  emit('update:modelValue', internalHtml.value);
}

onMounted(async () => {
  await nextTick();
  if (editorRef.value && internalHtml.value) {
    editorRef.value.innerHTML = internalHtml.value;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "px-3 py-1.5 rounded-lg text-zinc-200 bg-[#181818] hover:bg-[#202020] border border-zinc-700",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (formatAs('h1')))
      }, "H1"),
      _createElementVNode("button", {
        class: "px-3 py-1.5 rounded-lg text-zinc-200 bg-[#181818] hover:bg-[#202020] border border-zinc-700",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (formatAs('h2')))
      }, "H2"),
      _createElementVNode("button", {
        class: "px-3 py-1.5 rounded-lg text-zinc-200 bg-[#181818] hover:bg-[#202020] border border-zinc-700",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (formatAs('p')))
      }, "Text"),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "w-px h-6 bg-zinc-800 mx-1" }, null, -1)),
      _createElementVNode("button", {
        class: "px-3 py-1.5 rounded-lg text-black bg-gold-primary hover:bg-gold-secondary border border-gold-secondary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (exec('bold')))
      }, _cache[4] || (_cache[4] = [
        _createElementVNode("span", { class: "font-semibold" }, "B", -1)
      ]))
    ]),
    _createElementVNode("div", {
      ref_key: "editorRef",
      ref: editorRef,
      class: "px-4 py-4 min-h-[320px] outline-none prose prose-invert max-w-none focus:shadow-inner",
      contenteditable: "true",
      placeholder: _ctx.placeholder || 'Write a beautiful note…',
      onInput: onInput
    }, null, 40, _hoisted_3)
  ]))
}
}

})